import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import JrDotDragContainer from '../ui/JrDotDragContainer';

export default class JrQuestionDisplay extends Phaser.GameObjects.Container {
  constructor(scene) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;

    this.box1 = new JrDotDragContainer(this.scene, this);
    this.box2 = new JrDotDragContainer(this.scene, this);
    this.box2.x = 628;
  }

  displayNumbers(num1, num2) {
    this.box1.showDotSet(num1.value);
    this.box2.showDotSet(num2.value);

    this.scene.time.delayedCall(500, () => { this.showQuestionStuff(); });
  };

  showQuestionStuff() {
    this.emit('QUESTION_READY');
  };

  layoutRatio() {
    this.box2.x = 597;
  };
}